import { render, staticRenderFns } from "./IssueContainer.vue?vue&type=template&id=8d524bcc&scoped=true&"
import script from "./IssueContainer.vue?vue&type=script&lang=js&"
export * from "./IssueContainer.vue?vue&type=script&lang=js&"
import style0 from "./IssueContainer.vue?vue&type=style&index=0&id=8d524bcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d524bcc",
  null
  
)

export default component.exports